import { ISlotDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { ISlotLabelDecorator } from './i.slot-label-decorator';

export class SlotNameLabelDecorator implements ISlotLabelDecorator {
    public writeLabel = (item: ISlotDto, label: string): string => {
        return `${item.name}`;
    };
}
